/** Recommended upload sizes — match AdUnit.css display slots (@2x for sharp screens). */

export const AD_IMAGE_SPECS = {
  sidebar: {
    placement: 'sidebar',
    label: 'Sidebar ad',
    width: 720,
    height: 405,
    ratio: '16:9',
    displayNote: 'Shown full-width at the top of the sidebar card (~360px on desktop).',
    tip: 'Use a clear photo, logo, or graphic. The full image is shown (no crop) inside a 16:9 frame.',
    formats: 'JPG, PNG, or WebP',
    maxMb: 8,
  },
  banner: {
    placement: 'banner',
    label: 'Top partner banner',
    width: 640,
    height: 144,
    ratio: '40:9',
    displayNote: 'Wide logo strip shown at the top of the homepage (beside title & text).',
    tip: 'Use a horizontal logo or brand mark (like a partner ad). Full image is shown — no crop.',
    formats: 'JPG, PNG, or WebP',
    maxMb: 8,
  },
};

export function getAdImageSpec(placement) {
  return AD_IMAGE_SPECS[placement === 'banner' ? 'banner' : 'sidebar'];
}

export function adImageUploadHint(placement) {
  const s = getAdImageSpec(placement);
  return `${s.formats} · max ${s.maxMb} MB · recommended ${s.width}×${s.height}px (${s.ratio})`;
}

export function adImageSizeLine(placement) {
  const s = getAdImageSpec(placement);
  return `${s.width} × ${s.height} px · ${s.ratio}`;
}
